export default "__VITE_ASSET__C9uVNC_m__"